var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSpringWhite(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 185.703,
    height: 199.009,
    viewBox: "0 0 185.703 199.009",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_60885",
    "data-name": "Group 60885",
    transform: "translate(2.095 48.416) rotate(-20)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_82191",
    "data-name": "Path 82191",
    d: "M42.064,159.267s21.654-81.592-18.12-142.9-29.958,68.7,29.165,78.26S97.9,23.348,79.45,16.366,67.9,65.721,102.015,72.726c17.194,3.53,27.684-9.922,33.892-24.2",
    transform: "translate(0 0)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_39971",
    "data-name": "Ellipse 39971",
    cx: 6.842,
    cy: 6.842,
    rx: 6.842,
    ry: 6.842,
    transform: "translate(135.911 30.745)",
    fill: "#2aeaaf"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpringWhite);
export default __webpack_public_path__ + "static/media/spring-white.2585fb0771ab28001a06b33b0edc04d9.svg";
export { ForwardRef as ReactComponent };